import makeStyles from '@material-ui/core/styles/makeStyles';
import { getStatusColor } from '../../../utilities/StatusUtilities';

export const useTooltipStyles = makeStyles((theme) => ({
    borderLineTop: {
        borderTop: '1px solid #ccc',
    },
    noDataText: {
        fontSize: '13px',
        lineHeight: '13px',
        filter: theme.palette.type === 'light' ? '' : 'brightness(2)',
    },
    granularityText: {
        fontSize: '12px',
        lineHeight: '12px',
        filter: theme.palette.type === 'light' ? '' : 'brightness(2)',
        fontWeight: 'bold',
    },
    entityNameHeader: {
        paddingBottom: 8, // NJA: it looked weird having a test name in grey (unlike the date/time header), so skip the grey color
    },
    header: {
        color: '#6f6f6f',
        paddingBottom: 8,
    },
    headerDesciption: {
        fontSize: '12px',
    },
    headerTitle: {
        fontWeight: 'bold',
    },
    statusPlotbandPointHeader: {
        margin: '4px 0px 8px 0px',
        textAlign: 'center',
        lineHeight: '24px',
        height: '24px',
        borderRadius: '2px',
    },
    statusValue: {
        display: 'inline',
        fontWeight: 'bold',
        paddingRight: '4px',
    },
    thresholdNormal: {
        opacity: 0.7,
    },
    thresholdDegraded: {
        backgroundColor: getStatusColor('yellow', 0.4),
        height: '22px',
        fontWeight: 'bold',
    },
    thresholdExcessive: {
        backgroundColor: getStatusColor('orange', 0.4),
        height: '22px',
        fontWeight: 'bold',
    },
    thresholdTooltipHeader: {
        width: '80px',
        textAlign: 'right',
        fontWeight: 'bold',
    },
    thresholdTooltipPoint: {
        fontSize: '13px',
        lineHeight: '13px',
        padding: '5px 5px',
    },
    thresholdTooltipPointLabel: {
        padding: '0 2px',
    },
    tooltipPointThreshold: {
        color: theme.palette.text.secondary,
        fontWeight: 'bold',
        textAlign: 'right',
        paddingLeft: '10px',
    },
    thresholdTooltipPointValue: {
        textAlign: 'right',
    },
    timestampText: {
        fontSize: '13px',
        fontWeight: 'bold',
        filter: theme.palette.type === 'light' ? '' : 'brightness(2)',
    },
    tooltipPoint: {
        fontSize: '13px',
        lineHeight: '13px',
    },
    tooltipPointColorBox: {
        display: 'inline-block',
        height: '6px',
        width: '6px',
        margin: '6px 0',
        verticalAlign: 'middle',
        textAlign: 'center',
        border: '1px thin #444',
        borderRadius: '3px',
    },
    tooltipPointHeaderLabel: {
        color: '#6f6f6f',
        fontSize: '12px' || theme.typography,
        paddingTop: theme.spacing(0),
        paddingRight: theme.spacing(1.25),
        paddingBottom: theme.spacing(0.625),
        paddingLeft: theme.spacing(1.25),
        textAlign: 'right',
        filter: theme.palette.type === 'light' ? '' : 'brightness(2)',
    },
    tooltipPointLabel: {
        padding: '0 6px',
    },
    tooltipPointValue: {
        fontWeight: 'bold',
        textAlign: 'right',
        paddingTop: 0,
        paddingRight: theme.spacing(1.25),
        paddingBottom: theme.spacing(0.5),
        paddingLeft: theme.spacing(1.25),
    },
    tooltipTable: {
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: '0px',
    },
    tooltipAnnotation: {
        fontSize: '13px',
        textAlign: 'left',
    },
}));
